export default "__VITE_ASSET__xQi2ucKE__"